import React, { useEffect, useState } from "react";

import LiveView from "./LiveView";
import "./index.css";

const LivePage = () => {
  const [animation, setAnimation] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimation(true);
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={`live-view ${animation ? "active" : ""}`}>
      <LiveView />
    </div>
  );
};

export default LivePage;
